import React, { useEffect, useState } from 'react';
import { Typography } from 'ui-v2/components/Typography';
import { Button } from 'ui-v2/components/Button';
import { ProductDescription } from 'src/modules/parkplusStoreV2/types/product';
import Dropdown from './Dropdown';
import s from './MoreProductDetails.module.scss';
import { trackCtaClickedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';

type MoreProductDetailsProps = {
  data: ProductDescription;
};

export const MoreProductDetails: React.FunctionComponent<
  MoreProductDetailsProps
> = ({ data }) => {
  const [showAll, setShowAll] = useState(false);
  const [openCount, setOpenCount] = useState(0);

  const handleOpenCount = (operation: string) => {
    if (operation === 'INCREASE') {
      setOpenCount((prev) => prev + 1);
    } else setOpenCount((prev) => prev - 1);
  };
  useEffect(() => {
    if (openCount === data?.productSummaries?.length) {
      setShowAll(true);
    }
    if (openCount == 0) {
      setShowAll(false);
    }
  }, [data?.productSummaries?.length, openCount]);
  if (!data) {
    return null;
  }

  return (
    <div className={s.reviewsContainer}>
      <div className={s.title}>
        <Typography label="Product Details" variant="label_2_bold" />
        <Button
          label={showAll ? 'Collapse all' : 'Expand all'}
          size="small"
          variant="link_color"
          onClick={() => {
            if (showAll) {
              setShowAll(false);
              setOpenCount(0);
            } else {
              setShowAll(true);
              setOpenCount(data?.productSummaries?.length);
            }
            trackCtaClickedStoreV2(
              'Product Details',
              showAll ? 'Collapse all' : 'Expand all'
            );
          }}
        />
      </div>

      {/* benefits */}
      {data?.productSummaries?.map((item, ind) => (
        <Dropdown
          label={item?.title}
          isOpen={showAll}
          content={item?.content}
          data={item?.data}
          contentType={item?.contentType}
          key={ind}
          handleOpenCount={handleOpenCount}
        />
      ))}
    </div>
  );
};
